// extracted by mini-css-extract-plugin
module.exports = {"Controls":"Controls_Controls__3E7kZ"};